export const signUpFormDefaults = {
  username: '',
  email: '',
  passwordOne: '',
  passwordTwo: '',
  error: null
}



// WEBPACK FOOTER //
// ./src/constants/signUpFormDefaults.js